export interface RateArray {
  rateId: number;
  rateCategoryName: string;
  rates: Rates;
}

export interface Rates {
  january: number | null;
  february: number | null;
  march: number | null;
  april: number | null;
  may: number | null;
  june: number | null;
  july: number | null;
  august: number | null;
  september: number | null;
  october: number | null;
  november: number | null;
  december: number | null;
}

export interface RateGetResponse {
  yearId: number;
  ratesArray: RateArray[];
}

export const EmptyRateGetResponse: RateGetResponse = {
  yearId: 0,
  ratesArray: [
    {
      rateId: 0,
      rateCategoryName: '',
      rates: {
        january: null,
        february: null,
        march: null,
        april: null,
        may: null,
        june: null,
        july: null,
        august: null,
        september: null,
        october: null,
        november: null,
        december: null,
      },
    },
  ],
};
